export default __webpack_public_path__ + "static/media/contact3S.602c8dd7.webp";